/**
 * Created by hyr111276 on 2018/1/11.
 */
// import MsgBox from './msgbox';
// import {native} from '@ali/amap-lib';
import jumpCommonPage from '../js/jump-common-page';
import CONFIG_URL from '../../config/config.url';
import toast from '@ali/act-util/toast';
import { EventBus } from '../js/event-bus';

export default function (aosUrl, errorCode,actId) {
  switch (true) {
    case errorCode === 102://活动未开始
      EventBus.$emit('activity.status.notBegin');
      break;
    case errorCode === 103://活动已结束
      EventBus.$emit('activity.status.ended');
      break;
    case errorCode === 104://活动已下线
      EventBus.$emit('activity.status.Offline');
      break;
    case errorCode === -10: //弱网
      toast('网络不好，请重试');
      break;
    case errorCode <= 0: //断网
      toast('网络不好，请重试');
      break;
    default:
      jumpCommonPage.goErrorPage({
        code: errorCode,
        actUrl: `${CONFIG_URL.index}?act_id=${actId}`,
        actName: '2021GasInviter', // 项目分支名等
      });
  }
}
